import { useAppSystem } from 'Store/app';
import { useHostStockPromoState } from 'View/host-stock-promo/state';
import ScrollToTopUiKit from 'UiKit/scroll-to-top';

const ScrollToTop = () => {
  const { state } = useHostStockPromoState();
  const { isHideMobileNavBar } = useAppSystem();

  return (
    <ScrollToTopUiKit
      show={state?.showScrollToTop}
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      bottom={!isHideMobileNavBar ? '136px' : '100px'}
    />
  );
};

export default ScrollToTop;
